import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export default baseKey => {
  const { t, ready } = useTranslation('common', { useSuspense: false });
  return useMemo(() => (field, interpolatedValues) => (ready ? t(`${baseKey}.${field}`, interpolatedValues) : ''), [baseKey, ready, t]);
};
